import { jsx, Fragment } from "react/jsx-runtime";
import { Tooltip, MarkdownRenderer, List, ListItem } from "@nxt-costco-com/forge-components";
import { Info } from "@nxt-costco-com/forge-icons";
import { HTML_ESCAPE_PATTERNS } from "./constants.js";
const MarkdownTooltipOverride = ({
  content,
  ariaLabel = "Delivery Date info",
  id = "default-tooltip-id",
  tooltipStyles = {},
  ...props
}) => {
  if (typeof content !== "string") {
    console.error(
      `[MarkdownTooltipOverride][Error]: Invalid content type: expected string but received ${typeof content}`
    );
    return null;
  }
  const unescapeContent = (str) => {
    try {
      return HTML_ESCAPE_PATTERNS.reduce((result, pattern) => {
        return result.replaceAll(pattern.escaped, pattern.unescaped);
      }, str);
    } catch (error) {
      console.error(
        "[MarkdownTooltipOverride][Error]: Error unescaping content:",
        error
      );
      return str;
    }
  };
  const processedContent = unescapeContent(content);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    Tooltip,
    {
      buttonAriaLabel: ariaLabel,
      buttonContent: /* @__PURE__ */ jsx(Info, { width: "16", height: "16" }),
      buttonStyles: {
        ...tooltipStyles
      },
      content: /* @__PURE__ */ jsx(
        MarkdownRenderer,
        {
          markdown: processedContent,
          overrides: {
            p: {
              component: "div"
            },
            li: {
              component: ListItem
            },
            ul: {
              component: List
            },
            ol: {
              component: List,
              props: {
                variant: "OrderedList"
              }
            }
          }
        }
      ),
      position: "top",
      tooltipId: id,
      uniqueId: id,
      hasArrow: true,
      componentType: "div",
      offset: [0, 8],
      sx: {
        '&[data-popper-placement*="top"]': {
          ".arrow": {
            left: "-6px !important"
          }
        }
      },
      ...props
    }
  ) });
};
export {
  MarkdownTooltipOverride
};
